import { axiosInstance } from '../utils/axios';

const plantillasService = {
  async getAll() {
    const response = await axiosInstance.get('/plantillas');
    return response.data;
  },

  async getById(id) {
    const response = await axiosInstance.get(`/plantilla/${id}`);
    return response.data;
  },

  async getByTipoCliente(tipo) {
    const response = await axiosInstance.get(`/plantilla/tipo/${tipo}`);
    return response.data;
  },

  async create(data) {
    const response = await axiosInstance.post('/plantilla', data);
    return response.data;
  },

  async update(id, data) {
    const response = await axiosInstance.put(`/plantilla/${id}`, data);
    return response.data;
  },

  async remove(id) {
    await axiosInstance.delete(`/plantilla/${id}`);
  },
};

export default plantillasService;
